const cleanHTMLTags = (description: string): string => {
  const regex = /(<([^>]+)>)/gi
  const descriptionClean = description.replace(regex, '')
  return descriptionClean
}

export default cleanHTMLTags
